// extracted by mini-css-extract-plugin
export default {"profileContainer":"profile_profileContainer__OXqwj","profilePicture":"profile_profilePicture__fg8Yf"};